import { colorSystem } from '@luminovo/design-system';
import LinkIcon from '@mui/icons-material/Link';
import { styled } from '@mui/material';

export const StyledLinkIcon = styled(LinkIcon)({
    transform: `rotate(-45deg)`,
    fill: colorSystem.primary[5],
});
